import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import ReactTable from 'react-table';
import api from '../../../logic/api';
import {
  faPlus,
  faMap,
  faList,
  faMapMarker,
  faFilter,
} from '@fortawesome/pro-regular-svg-icons';
import mbxGeocoder from '@mapbox/mapbox-sdk/services/geocoding';
import history from '../../../history';
import settings from '../../../../settings';
import Loader from '../../../components/Loader';
import Searchbar from '../../../components/Searchbar';
import Button from '../../../components/Button';
import SearchDropdown from '../../../components/SearchDropdown';
import Dropdown from '../../../components/Inputs/Dropdown';
import DisordersMainFocus from '../../../components/DisordersMainFocus';
import Treatments from '../../../components/Treatments';
import getConstants from '../../../logic/constants';

import Map from '../../../components/Map';
import HeaderbarButton from '../../../components/HeaderbarButton';
import UserContext from '../../../hooks/UserContext';
import {
  ACCOMPANYING_OPTIONS,
  TREATMENT_SETTING_OPTIONS,
  TYPE_OF_CLINIC_OPTIONS,
  YES_NO_OPTIONS,
  labelOf,
  normalizeClinicRow,
} from './clinicData';
import {
  EMPTY_CLINIC_FILTERS,
  clearStoredClinicFilters,
  filterClinics,
  hasActiveClinicFilters,
  loadClinicFilters,
  saveClinicFilters,
} from './clinicFilters';
import { canEditClinics } from './clinicAccess';

const yesNoLabel = (value) => {
  if (value === true) return 'Ja';
  if (value === false) return 'Nein';
  return '';
};

class SupplynetworkOverview extends Component {
  constructor(props) {
    super(props);

    let searchString = '';
    if (props.match.params.search) {
      searchString = props.match.params.search;
    }

    this.geocodingClient = mbxGeocoder({
      accessToken: settings.external.mapbox_key,
    });

    const filters = loadClinicFilters();

    this.state = {
      loading: true,
      listView: true,
      data: [],
      searchString,
      searchLatLon: null,
      radius: '',
      filters,
      showFilters: hasActiveClinicFilters(filters),
      TherapyProcedures: [],
    };
  }

  componentDidMount() {
    api('get', settings.supplynetwork.clinics.getList).then((res) => {
      this.setState({
        data: JSON.parse(res).clinicList.map(normalizeClinicRow),
      });
      this.setState({
        loading: false,
      });
    });
    this.initConstants();
  }

  async initConstants() {
    this.setState({
      TherapyProcedures: await getConstants('TherapyProcedures'),
    });
  }

  _search = (value) => {
    const val = value.toLowerCase();

    history.replace(
      val ? `/supplynetwork/Clinics/search/${val}` : '/supplynetwork/Clinics',
    );

    this.setState({
      searchString: val,
    });
  };

  _streetSearch = (value) => {
    this.geocodingClient
      .forwardGeocode({
        query: value,
      })
      .send()
      .then((response) => {
        const match = response.body;
        if (!match.features.length) return;

        this.setState({
          searchLatLon: match.features[0].center,
        });
      });
  };

  _changeRadius = (value) => {
    this.setState({
      radius: value,
    });
  };

  _changeView = () => {
    this.setState({
      listView: !this.state.listView,
    });
  };

  _toggleFilters = () => {
    this.setState((prevState) => ({ showFilters: !prevState.showFilters }));
  };

  _changeFilter = (filterName, filterValue) => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          [filterName]: filterValue || EMPTY_CLINIC_FILTERS[filterName],
        },
      }),
      () => saveClinicFilters(this.state.filters),
    );
  };

  _resetFilters = () => {
    clearStoredClinicFilters();
    this.setState({ filters: { ...EMPTY_CLINIC_FILTERS } });
  };

  therapyProcedureShortcuts(values) {
    return this.state.TherapyProcedures.filter((option) =>
      values.includes(option.value),
    )
      .map((option) => option.kkz)
      .join(', ');
  }

  renderFilters() {
    const { filters } = this.state;
    return (
      <>
        <div className="Toolbar-Filter">
          <SearchDropdown
            name="FilterTypeOfClinic"
            label="Form des Klinikbetriebs:"
            options={TYPE_OF_CLINIC_OPTIONS}
            defaultValue={filters.TypeOfClinic}
            onChange={(value) => this._changeFilter('TypeOfClinic', value)}
          />
          <SearchDropdown
            name="FilterTreatmentSetting"
            label="Behandlungssetting:"
            options={TREATMENT_SETTING_OPTIONS}
            defaultValue={filters.TreatmentSetting}
            onChange={(value) => this._changeFilter('TreatmentSetting', value)}
          />
          <div className="SearchDropdown">
            <Dropdown
              fullWidth
              isMulti
              isClearable
              name="FilterTherapyProcedures"
              inputId="FilterTherapyProcedures"
              validator={[]}
              label="Therapieverfahren:"
              options={this.state.TherapyProcedures}
              defaultValue={filters.TherapyProcedures}
              getSelected={(values) =>
                this._changeFilter('TherapyProcedures', values)
              }
            />
          </div>
          <SearchDropdown
            name="FilterClinicEligble"
            label="beihilfefähig:"
            options={YES_NO_OPTIONS}
            defaultValue={filters.ClinicEligble}
            onChange={(value) => this._changeFilter('ClinicEligble', value)}
          />
          <SearchDropdown
            name="FilterLegallyInsuredPatientsTreated"
            label="Kostenübernahme GKV/Heilfürsorge:"
            options={YES_NO_OPTIONS}
            defaultValue={filters.LegallyInsuredPatientsTreated}
            onChange={(value) =>
              this._changeFilter('LegallyInsuredPatientsTreated', value)
            }
          />
        </div>
        <div className="Toolbar-Filter">
          <DisordersMainFocus
            name="FilterDisordersMainFocus"
            inputId="FilterDisordersMainFocus"
            label="Störungsbild-Schwerpunkt:"
            infoFocus="Kliniken mit mindestens einem der gewählten Schwerpunkte."
            mainFocus={filters.DisordersMainFocus}
            onChange={(values) =>
              this._changeFilter('DisordersMainFocus', values.mainFocus)
            }
          />
          <DisordersMainFocus
            name="FilterDisordersNotExcluded"
            inputId="FilterDisordersNotExcluded"
            label="Störungsbild nicht ausgeschlossen:"
            infoFocus="Blendet Kliniken aus, die eines der gewählten Störungsbilder ausschließen."
            mainFocus={filters.DisordersNotExcluded}
            onChange={(values) =>
              this._changeFilter('DisordersNotExcluded', values.mainFocus)
            }
          />
          <Treatments
            name="FilterTreatments"
            inputId="FilterTreatments"
            label="Besondere Behandlungsschwerpunkte:"
            info="Mehrfachauswahl ist möglich."
            values={filters.Treatments}
            onChange={(values) => this._changeFilter('Treatments', values)}
          />
          <div className="SearchDropdown">
            <Dropdown
              fullWidth
              isMulti
              isClearable
              name="FilterAccompanying"
              inputId="FilterAccompanying"
              validator={[]}
              label="Aufnahme von Begleitpersonen:"
              options={ACCOMPANYING_OPTIONS}
              defaultValue={filters.Accompanying}
              getSelected={(values) =>
                this._changeFilter('Accompanying', values)
              }
            />
          </div>
        </div>
      </>
    );
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    let data = [];
    if (this.state.data.length) {
      data = filterClinics(this.state.data, this.state.filters).filter(
        (rowData) => {
          return [
            rowData.ClinicName,
            rowData.Street,
            rowData.ZIP,
            rowData.City,
            rowData.Landline,
            rowData.MailToCare,
          ]
            .map((e) => {
              return e ? e.toLowerCase() : '';
            })
            .some((v) => {
              return v ? v.indexOf(this.state.searchString) >= 0 : false;
            });
        },
      );
    }

    return (
      <>
        <div className="Headerbar sticky ClinicsOverview">
          <div className="Headerbar-breadcrumbs">
            Versorgungsnetzwerk - <b>Klinken</b>
          </div>
          <div className="Headerbar-buttons">
            {this.state.listView ? (
              <HeaderbarButton
                icon={faMap}
                type="primary"
                onClick={this._changeView}
              >
                Kartenansicht
              </HeaderbarButton>
            ) : (
              <HeaderbarButton
                icon={faList}
                type="primary"
                onClick={this._changeView}
              >
                Listenansicht
              </HeaderbarButton>
            )}
          </div>
        </div>
        <div className="Split-Panes-Menu ClinicsOverview">
          <div className="Split-Pane-Menu">
            <div className="Split-Pane-Menu-Nav">
              <NavLink
                to="/supplynetwork/AmbulatoryPsychotherapy"
                className="FormArea-Body-Tab"
                activeClassName="is-Active"
              >
                Ambulante Psychotherapie
              </NavLink>
              <NavLink
                to="/supplynetwork/Clinics"
                className="FormArea-Body-Tab"
                activeClassName="is-Active"
              >
                Kliniken
              </NavLink>
              <NavLink
                to="/supplynetwork/Specialists"
                className="FormArea-Body-Tab"
                activeClassName="is-Active"
              >
                Fachärzte
              </NavLink>
            </div>
          </div>
          <div className="Split-Pane-Main">
            <div className="Page-Content">
              <div className="Buttonbar">
                <UserContext.Consumer>
                  {(context) =>
                    canEditClinics(context) ? (
                      <>
                        <Button icon={faPlus} to="/supplynetwork/Clinics/new">
                          Neue Adresse anlegen
                        </Button>
                      </>
                    ) : null
                  }
                </UserContext.Consumer>
              </div>
              <div className="Toolbar">
                {this.state.listView ? (
                  <Searchbar
                    key="searchString"
                    placeholder="Volltextsuche"
                    aria-label="Volltextsuche"
                    defaultValue={this.state.searchString}
                    onChange={this._search}
                  />
                ) : (
                  <Searchbar
                    key="searchLatLon"
                    icon={faMapMarker}
                    placeholder="Startadresse oder PLZ eingeben"
                    onChange={() => {}}
                    onBlur={this._streetSearch}
                  />
                )}
                {!this.state.listView && (
                  <Searchbar
                    disabled={!this.state.searchLatLon}
                    placeholder="Umkreis in km"
                    size="small"
                    onChange={this._changeRadius}
                  />
                )}
                <Button icon={faFilter} onClick={this._toggleFilters}>
                  {this.state.showFilters
                    ? 'Filter ausblenden'
                    : 'Filter einblenden'}
                </Button>
                {this.state.showFilters && (
                  <Button
                    type="primary"
                    icon={faFilter}
                    onClick={this._resetFilters}
                  >
                    Filter zurücksetzen
                  </Button>
                )}
                <span className="Searchbar-Results-Amount">
                  {data.length} Einträge
                </span>
                <div className="Toolbar-buttons"></div>
              </div>
              {this.state.showFilters && this.renderFilters()}
              {this.state.listView ? (
                <ReactTable
                  getTrProps={(_, val) => {
                    return {
                      onClick: () => {
                        return this.props.history.push(
                          `/supplynetwork/Clinics/${val?.original?.Guid}`,
                        );
                      },
                    };
                  }}
                  defaultSorted={[
                    {
                      id: 'City',
                      desc: false,
                    },
                  ]}
                  data={data}
                  pageSize={data.length}
                  noDataText="Es wurden keine Adressen gefunden."
                  columns={[
                    {
                      accessor: 'ClinicName',
                      Header: 'Name der Klinik',
                    },
                    {
                      id: 'City',
                      accessor: 'City',
                      Header: 'PLZ / Ort',
                      Cell: ({ original }) =>
                        [original.ZIP, original.City].filter(Boolean).join(' '),
                    },
                    {
                      id: 'TypeOfClinic',
                      Header: 'Form des Klinikbetriebs',
                      accessor: (row) =>
                        labelOf(TYPE_OF_CLINIC_OPTIONS, row.TypeOfClinic),
                    },
                    {
                      id: 'TreatmentSetting',
                      Header: 'Setting',
                      accessor: (row) =>
                        labelOf(
                          TREATMENT_SETTING_OPTIONS,
                          row.TreatmentSetting,
                        ),
                    },
                    {
                      id: 'TherapyProcedures',
                      Header: 'ThV',
                      accessor: (row) =>
                        this.therapyProcedureShortcuts(row.TherapyProcedures),
                    },
                    {
                      id: 'ClinicEligble',
                      Header: 'beihilfefähig',
                      accessor: (row) => yesNoLabel(row.ClinicEligble),
                    },
                    {
                      id: 'LegallyInsuredPatientsTreated',
                      Header: 'Kostenübernahme GKV',
                      accessor: (row) =>
                        yesNoLabel(row.LegallyInsuredPatientsTreated),
                    },
                    {
                      accessor: 'Landline',
                      Header: 'Telefon',
                    },
                    {
                      accessor: 'MailToCare',
                      Header: 'E-Mail CARE',
                    },
                  ]}
                />
              ) : (
                <Map
                  markers={data}
                  streetPoint={this.state.searchLatLon}
                  radius={this.state.radius}
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SupplynetworkOverview;
